import completeSubscription, { 
    getCompleteSubscriptionParams,
    processCompleteSubscription,
} from './completeSubscription';

import subscribe from './subscribe';
import subscriberActive from './subscriberActive';
import subscriberStatus from './subscriberStatus';
import subscriberStatusPoll from './subscriberStatusPoll';
import initOauthSession from './initOauthSession';
import oauthSession from './oauthSession';
import subscribeWithId from './subscribeWithId';
import subscribeFromForm from './subscribeFromForm';
import cleanPayload from './cleanPayload';

export const actions = {
    completeSubscription,
    getCompleteSubscriptionParams,
    subscribe,
    subscriberActive,
    subscriberStatus,
    oauthSession,
    initOauthSession,
    subscribeWithId,
    subscribeFromForm,
    subscriberStatusPoll,
    processCompleteSubscription,
    cleanPayload,
};

export default actions;
